import { Injectable } from '@angular/core';
import { ValidatorFn, AbstractControl } from '@angular/forms';
import { FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root',
})
export class ValidationService {
  constructor() {}

  passwordMinLowerCaseLettersValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      if (!control.value) {
        return null;
      }
      const valid = this.hasLowerCaseCharacters(control.value, 2).value;
      return valid ? null : { invalidPasswordMinLowerCaseLetters: true };
    };
  }

  passwordMatch(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): { [key: string]: any } | null => {
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl = formGroup.get(confirmPassword);

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      if (
        confirmPasswordControl.errors &&
        !confirmPasswordControl.errors.passwordMismatch
      ) {
        return null;
      }

      if (passwordControl.value !== confirmPasswordControl.value) {
        confirmPasswordControl.setErrors({ passwordMismatch: true });
        return { passwordMismatch: true };
      } else {
        confirmPasswordControl.setErrors(null);
        return null;
      }
    };
  }

 hasLowerCaseCharacters(value: string, minCount: number): { value: boolean; count: number } {
    const lowerCaseRegex = /[a-z]/g;
    const lowerCaseMatches = value.match(lowerCaseRegex) || [];
    const count = lowerCaseMatches.length;
    const isValid = count >= minCount;

    return { value: isValid, count };
}

}